import script from "./splashScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./splashScreen.vue?vue&type=script&setup=true&lang=js"

import "./splashScreen.vue?vue&type=style&index=0&id=a2e61f10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2e61f10"]])

export default __exports__